import axios from "axios";
import { toast } from "react-toastify";
import { getKeyword, getPageable } from "..";
import {
  API_ADMIN,
  API_CONFIG,
  API_EMAIL,
  API_MEMBER_IMPORT_FILE,
  API_MEMBER_RESET_PASSWORD,
  API_MEMBERSHIP_OTP_SEND,
  API_MEMBERSHIP_OTP_VERIFY,
  API_MEMBERSHIP_WALK_IN,
  API_MEMBERSHIP_TNC,
  API_ENTRIES_APPLICATIONS,
  API_FESTIVAL_PASS,
  API_FILM,
  API_FILM_CATEGORY,
  API_FILM_ICON,
  API_FILM_IMPORT_FILE,
  API_FILM_IMPORT_IMAGE,
  API_FILM_SUBCATEGORY,
  API_FILM_TAG,
  API_HKIFF_PROGRAMME,
  API_HKIFF_PROGRAMME_CATEGORY,
  API_HKIFF_PROGRAMME_TYPE,
  API_HKIFF_PROGRAMME_SCREENING_CODE,
  API_GET_ADMIN_INFO,
  API_GET_PAGE,
  API_GIFT,
  API_GUEST_ACCREDITATION,
  API_INVITED_ACCREDITATION,
  API_GUEST_TEMPLATE,
  API_CONTACT_US,
  API_SUPPORT_US,
  API_ORGANIZATION,
  API_POSITION,
  API_EMPLOYEE,
  API_HKIFF_APP,
  API_HKIFF_APP_BANNER,
  API_HKIFF_APP_MENU,
  API_HKIFF_BANNER,
  API_HKIFF_CONFIG,
  API_HKIFF_EDM,
  API_HKIFF_EVENT,
  API_HKIFF_EVENT_CATEGORY,
  API_HKIFF_FESTIVAL,
  API_HKIFF_MENU,
  API_HKIFF_NEWS,
  API_HKIFF_NEWS_BULK_SEQ,
  API_HKIFF_REGION,
  API_HKIFF_SPONSOR,
  API_HKIFF_SPONSOR_CATEGORY,
  API_HKIFF_SUBSCRIBE,
  API_HKIFF_TEMPLATE,
  API_HKIFF_UPLOAD,
  API_HKIFF_PRODUCT_CATEGORY,
  API_HKIFF_PRODUCT,
  API_HKIFF_PRODUCT_TAG,
  API_HKIFF_REPORT,
  API_HKIFF_VENUE,
  API_HKNT_ADMIN,
  API_HKNT_GET_PAGE,
  API_HKNT_HOMEPAGE,
  API_HKNT_MENU,
  API_HKNT_MOVIE,
  API_HKNT_MOVIE_IMPORT_FILE,
  API_HKNT_MOVIE_IMPORT_IMAGE,
  API_HKNT_MOVIES,
  API_HKNT_NOTE,
  API_HKNT_OPTION,
  API_HKNT_PAGE_IMPORT_FILE,
  API_HKNT_PAGE_IMPORT_IMAGE,
  API_HKNT_PAGES,
  API_HKNT_PARENT_PERIOD,
  API_HKNT_PERIOD,
  API_HKNT_PERIOD_BULK,
  API_HKNT_PROGRAMME,
  API_HKNT_PROGRAMMEBYID,
  API_HKNT_REMARK,
  API_HKNT_REMARKS,
  API_HKNT_REMARKS_BULK,
  API_HKNT_ROLES,
  API_HKNT_ROTATING_BANNER,
  API_HKNT_ROTATING_BANNERS,
  API_HKNT_TAG,
  API_HKNT_TAGS,
  API_HKNT_TAGS_BULK,
  API_HKNT_UPLOAD,
  API_HKIFF_JOB,
  API_HKIFF,
  API_HOMEPAGE,
  API_INVITED_ENTRIES,
  API_LOGIN,
  API_LOGOUT,
  API_MEDIA_ACCREDITATION,
  API_MEDIA_TEMPLATE,
  API_MEMBERS,
  API_MENU,
  API_MOVIE,
  API_MOVIES_BULK,
  API_MOVIE_IMPORT_FILE,
  API_MOVIE_IMPORT_IMAGE,
  API_MOVIES,
  API_NOTE,
  API_OPTION,
  API_ORDERS,
  API_PAGE_IMPORT_FILE,
  API_PAGE_IMPORT_IMAGE,
  API_PAGES,
  API_PARENT_PERIOD,
  API_PERIOD,
  API_PERIOD_BULK,
  API_PLAN,
  API_PROGRAMME,
  API_PROGRAMMEBYID,
  API_REFUND_FORM_APP,
  API_REFUND_FORM_EMAIL_CONFIG,
  API_REFUND_FORM_FILM_LIST,
  API_REFUND_FORM_IMPORT_FILM_NAMES,
  API_REFUND_FORM_PROGRAMMES,
  API_REFUND_FORM_TNC,
  API_REFUND_FORM_VENUES,
  API_REMARK,
  API_REMARKS,
  API_REMARKS_BULK,
  API_ROLES,
  API_ROTATING_BANNER,
  API_ROTATING_BANNERS,
  API_TAG,
  API_TAGS,
  API_TAGS_BULK,
  API_TICKETING,
  API_UPLOAD,
  API_HKIFF_TRANSACTION_EMAIL,
  API_HKIFF_LOGO,
  API_HKIFF_TRANSACTION,
  API_HKIFF_TRANSACTION_ORDER_STATUS,
  API_MEMBERSHIP_SHOP,
  API_MEMBERSHIP_VOUCHER,
  API_MEMBERSHIP_VOUCHER_IMPORT_IMAGE,
  API_MEMBERSHIP_VOUCHER_PRODUCT,
  API_MEMBERSHIP_SHOP_COUPONS,
  API_MEMBERSHIP_COUPON_PRODUCT,
  API_MEMBERSHIP_SHOP_MERCHANDISE,
  API_MEMBERSHIP_SHOP_MERCHANDISE_BY_ID,
  API_MEMBERSHIP_HOMEPAGE_BANNERS,
  API_MEMBERSHIP_HOMEPAGE_PARTNERS,
  API_MEMBERSHIP_NEWS,
  API_MEMBERSHIP_NEWS_BY_ID,
  API_MEMBERSHIP_FAQ,
  API_MEMBERSHIP_FAQ_BY_ID,
  API_MEMBERSHIP_FAQ_BULK_SEQ,
  API_MEMBERSHIP_FAQ_CATEGORY,
  API_MEMBERSHIP_FAQ_CATEGORY_BY_ID,
  API_MEMBERSHIP_FAQ_CATEGORY_BULK_SEQ,
  API_MEMBERSHIP_UPLOAD,
  API_HKIFF_AWARD_CATEGORY,
  API_HKIFF_AWARD,
  API_JURY,
  API_HISTORY_CULTURE,
  API_COMPANY,
  API_HKIFF_PAGE_WORD,
  API_HKIFF_DISTRICT,
  API_SHIPPING,
  API_HKIFF_ESHOP,
  API_HKIFF_SCORE_BOARD,
  API_HKIFF_ACA_FILM_LIST,
  API_ACA_FILM_IMPORT_FILE,
  API_HKIFF_ACA_BANNER,
  API_HKIFF_ACA_SETTING,
} from "./constant";

export const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_HOSTNAME || (process.env.NODE_ENV === "development" ? "" : "https://hkiff-api-uat.cloud.udev.hk"),
  headers: {
    "Accept-Language": "en",
    "Content-Type": "application/json",
  },
  withCredentials: true,
  timeout: process.env.NODE_ENV === "development" ? null : 10000,
});

api.interceptors.response.use(
  function (response) {
    // process.env.NODE_ENV === "development" && console.log(response);
    // process.env.NODE_ENV === "development" && console.log(response.data);

    return response;
  },
  function (error) {
    process.env.NODE_ENV === "development" && console.log(error.response);

    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      window.location.href = "/login";
      // handle general error here
    }
    // toast.error(error.response && error.response.data.message);
    const message = error.response && error.response.data.message;
    const formattedMessage = message ? message.replace(/\n/g, '<br/>') : '';
    toast.error(<div dangerouslySetInnerHTML={{ __html: formattedMessage }} />);
    return error.response;
  }
);

const adminLogin = (data) => {
  return api.post(API_LOGIN, data);
};

const adminLogout = () => {
  return api.post(API_LOGOUT);
};

const adminInfo = () => {
  return api.get(API_GET_ADMIN_INFO);
};

const getHomepage = () => {
  return api.get(API_HOMEPAGE);
};

const updateHomepage = (homepage) => {
  return api.put(API_HOMEPAGE, homepage);
};

const getPagesByCategory = (category) => {
  return api.get(API_GET_PAGE(category));
};

const updateAdminInfo = (data) => {
  return api.put(API_GET_ADMIN_INFO, data);
};

const getMovies = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null,
  date = null,
  unpaged = false
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MOVIES}${getPageable(page, offset, pageSize)}${getStatus(
      status
    )}${getKeyword(keyword)}${getDate(date)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getAllMovies = (
  lang = "en",
  status = null,
  keyword = null,
  date = null
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  return api.get(
    `${API_MOVIES}?unpaged=true${getStatus(status)}${getKeyword(
      keyword
    )}${getDate(date)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getMovieById = (id) => {
  return api.get(API_MOVIE(id));
};

const updateMovieById = (id, data) => {
  return api.put(API_MOVIE(id), data);
};

const createMovie = (data) => {
  return api.post(API_MOVIES, data);
};

const deleteMovie = (id) => {
  return api.delete(API_MOVIE(id));
};

const bulkPublishMovies = (ids) => {
  return api.post(API_MOVIES_BULK, 
    { ids: ids, status: "PUBLISHED" },
  );
};

const getMovieNote = () => {
  return api.get(API_NOTE);
};

const updateMovieNote = (note) => {
  return api.put(API_NOTE, note);
};

const getAllRemarks = () => {
  return api.get(API_REMARKS);
};

const getRemarkById = (id) => {
  return api.get(API_REMARK(id));
};

const updateRemarkById = (id, remark) => {
  return api.put(API_REMARK(id), remark);
};

const deleteRemarkById = (id) => {
  return api.delete(API_REMARK(id));
};

const bulkDeleteRemarks = (ids) => {
  return api.delete(API_REMARKS_BULK, {
    data: { ids: ids, status: "DELETED" },
  });
};

const postRemark = (remark) => {
  return api.post(API_REMARKS, remark);
};

const getAllRotatingBanners = () => {
  return api.get(API_ROTATING_BANNERS);
};

const updateRotatingBannerById = (id, rotatingBanner) => {
  return api.put(API_ROTATING_BANNER(id), rotatingBanner);
};

const deleteRotatingBannerById = (id) => {
  return api.delete(API_ROTATING_BANNER(id));
};

const postRotatingBanner = (rotatingBanner) => {
  return api.post(API_ROTATING_BANNERS, rotatingBanner);
};

const getAllTags = () => {
  return api.get(API_TAGS);
};

const getTagById = (id) => {
  return api.get(API_TAG(id));
};

const deleteTagById = (id) => {
  return api.delete(API_TAG(id));
};

const updateTagById = (id, tag) => {
  return api.put(API_TAG(id), tag);
};

const createTag = (tag) => {
  return api.post(API_TAGS, tag);
};

const bulkDeleteTags = (ids) => {
  return api.delete(API_TAGS_BULK, { data: { ids } });
};

const bulkUpdateTagSequence = (data) => {
  return api.put(`${API_TAGS_BULK}/seq`, data);
};

const uploadFile = (imageFile) => {
  let bodyFormData = new FormData();
  bodyFormData.append("uploadImage", imageFile);

  return api.post(API_UPLOAD, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const uploadHKIFFFile = (imageFile, folder) => {
  let bodyFormData = new FormData();
  bodyFormData.append("uploadFile", imageFile);

  return api.post(
    folder ? API_HKIFF_UPLOAD(folder) : API_HKIFF_UPLOAD,
    bodyFormData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

const getPages = (data) => {
  return api.get(API_PAGES, { params: data });
};

const getPageById = (id) => {
  return api.get(`${API_PAGES}/${id}`);
};

const updatePageById = (id, data) => {
  return api.put(`${API_PAGES}/${id}`, data);
};

const deletePage = (id) => {
  return api.delete(`${API_PAGES}/${id}`);
};

const createPage = (data) => {
  return api.post(API_PAGES, data);
};

const getPeriodList = (data) => {
  return api.get(API_PERIOD, { params: data });
};

const getPeriodById = (id) => {
  return api.get(`${API_PERIOD}/${id}`);
};

const addPeriod = (data) => {
  return api.post(API_PERIOD, data);
};

const updatePeriod = (id, data) => {
  return api.put(`${API_PERIOD}/${id}`, data);
};

const updatePeriodOrder = (data) => {
  return api.put(`${API_PERIOD}/period-order`, { periodSequences: data });
};

const deletePeriod = (id) => {
  return api.delete(`${API_PERIOD}/${id}`);
};

const bulkDeletePeriod = (ids) => {
  return api.delete(`${API_PERIOD_BULK}`, { data: { ids } });
};

const getParentPeriodList = () => {
  return api.get(API_PARENT_PERIOD);
};

const getMenu = () => {
  return api.get(API_MENU);
};

const getMenuById = (id) => {
  return api.get(`${API_MENU}/${id}`);
};

const updateMenu = (id, data) => {
  return api.put(`${API_MENU}/${id}`, data);
};

const getProgrammes = (
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null
) => {
  return api.get(
    `${API_PROGRAMME}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getAllProgrammes = (lang = "en", keyword) => {
  return api.get(`${API_PROGRAMME}?unpaged=true${getKeyword(keyword)}`);
};

const createProgramme = (data) => {
  return api.post(API_PROGRAMME, data);
};

const getProgrammeById = (id) => {
  return api.get(API_PROGRAMMEBYID(id));
};

const updpateProgrammeById = (id, data) => {
  return api.put(API_PROGRAMMEBYID(id), data);
};

const deleteProgrammeById = (id) => {
  return api.delete(API_PROGRAMMEBYID(id));
};

const updateProgrammeSeq = (data) => {
  return api.put(`${API_PROGRAMME}/bulk/seq`, data);
};

const getAllAdmins = () => {
  return api.get(API_ADMIN);
};

const getAdminsById = (roleId) => {
  return api.get(`${API_ADMIN}?roleId=${roleId}`);
};

const addAdmins = (data) => {
  return api.post(API_ADMIN, data);
};

const getAdminsByRole = (role) => {
  return api.get(`${API_ROLES}/${role}`);
};

const getAdminById = (id) => {
  return api.get(`${API_ADMIN}/${id}`);
};

const updateAdminById = (id, data) => {
  return api.put(`${API_ADMIN}/${id}`, data);
};

const getRoles = () => {
  return api.get(API_ROLES);
};

const getOptions = () => {
  return api.get(API_OPTION);
};

const updateOptions = (data) => {
  return api.put(API_OPTION, data);
};

const importMovie = (data) => {
  return api.post(API_MOVIE_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const importMovieImage = (data) => {
  return api.post(API_MOVIE_IMPORT_IMAGE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const importPage = (data) => {
  return api.post(API_PAGE_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const importPageImage = (data) => {
  return api.post(API_PAGE_IMPORT_IMAGE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// HKIFF apis

const getInvitedEntries = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  return api.get(
    `${API_INVITED_ENTRIES}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getInvitedEntryById = (id) => {
  return api.get(`${API_INVITED_ENTRIES}/${id}`);
};

const getGuests = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_GUEST_ACCREDITATION}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getGuestById = (id) => {
  return api.get(`${API_GUEST_ACCREDITATION}/${id}`);
};

const deleteGuestById = (id) => {
  return api.delete(`${API_GUEST_ACCREDITATION}/${id}`);
};

const updateGuestById = (id, req) => {
  return api.put(`${API_GUEST_ACCREDITATION}/${id}`, req);
};

const getInvitedAccreditations = (page = 0, size = 10, keyword = "", cat = "") => {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  const catParam = cat ? `&cat=${cat}` : "";
  return api.get(`${API_INVITED_ACCREDITATION}?page=${page}&size=${size}${keywordParam}${catParam}`);
};

const importInvitedAccreditations = (formData) => {
  return api.post(`${API_INVITED_ACCREDITATION}/import`, formData);
};

const sendInvitedAccreditationEmail = (id) => {
  return api.post(`${API_INVITED_ACCREDITATION}/${id}/email`);
};

const bulkDeleteInvitedAccreditations = (ids) => {
  return api.delete(`${API_INVITED_ACCREDITATION}/bulk/delete`, { data: { ids } });
};

const getGuestTemplates = (type = null) => {
  function getType(type) {
    return type ? `/${type}` : "";
  }

  return api.get(`${API_GUEST_TEMPLATE}${getType(type)}`);
};

const saveGuestTemplate = (type, data) => {
  return api.put(`${API_GUEST_TEMPLATE}/${type}`, data);
};

const sendGuestEmailById = (id, type) => {
  return api.post(`${API_GUEST_ACCREDITATION}/${id}/email?type=${type}`);
};

const getGuestConfig = () => {
  return api.get(`${API_GUEST_ACCREDITATION}/configs/email/settings`);
};

const updateGuestConfig = (data) => {
  return api.put(`${API_GUEST_ACCREDITATION}/configs/email/settings`, data);
};

const getContactUs = () => {
  return api.get(`${API_CONTACT_US}`);
};

const updateContactUs = (data) => {
  return api.put(`${API_CONTACT_US}`, data);
};

const getSupportUsListing = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
}) => {
  function getStatus(status) {
    return status === 0 || status === 1 ? `&status=${status}` : "";
  }

  return api.get(
    `${API_SUPPORT_US}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}`
  );
};

const createSupportUs = (data) => {
  return api.post(API_SUPPORT_US, data);
};
const getSupportUsById = (id) => {
  return api.get(`${API_SUPPORT_US}/${id}`);
};
const updateSupportUsById = (id, data) => {
  return api.put(`${API_SUPPORT_US}/${id}`, data);
};

const deleteSupportUsById = (id) => {
  return api.delete(`${API_SUPPORT_US}/${id}`);
};

const orderSupportUsListing = (data) => {
  return api.put(`${API_SUPPORT_US}/bulk/seq`, data);
};

const getOrganizations = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_ORGANIZATION}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getOrganizationById = (id) => {
  return api.get(`${API_ORGANIZATION}/${id}`);
};

const createOrganization = (req) => {
  return api.post(`${API_ORGANIZATION}`, req);
};

const updateOrganizationById = (id, req) => {
  return api.put(`${API_ORGANIZATION}/${id}`, req);
};

const deleteOrganizationById = (id) => {
  return api.delete(`${API_ORGANIZATION}/${id}`);
};

const updateOrganizationSeq = (array) => {
  return api.put(`${API_ORGANIZATION}/sequence`, {
    sequenceList: array,
  });
};

const getPositions = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_POSITION}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getPositionById = (id) => {
  return api.get(`${API_POSITION}/${id}`);
};

const createPosition = (req) => {
  return api.post(`${API_POSITION}`, req);
};

const updatePositionById = (id, req) => {
  return api.put(`${API_POSITION}/${id}`, req);
};

const updatePositionSeq = (array) => {
  return api.put(`${API_POSITION}/sequence`, {
    sequenceList: array,
  });
};

const deletePositionById = (id) => {
  return api.delete(`${API_POSITION}/${id}`);
};

const getEmployees = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_EMPLOYEE}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getEmployeeById = (id) => {
  return api.get(`${API_EMPLOYEE}/${id}`);
};

const createEmployee = (req) => {
  return api.post(`${API_EMPLOYEE}`, req);
};

const updateEmployeeById = (id, req) => {
  return api.put(`${API_EMPLOYEE}/${id}`, req);
};

const deleteEmployeeById = (id) => {
  return api.delete(`${API_EMPLOYEE}/${id}`);
};

const updateEmployeeSeq = (array) => {
  return api.put(`${API_EMPLOYEE}/sequence`, {
    sequenceList: array,
  });
};

const getHistoryCulture = () => {
  return api.get(`${API_HISTORY_CULTURE}`);
};

const updateHistoryCulture = (data) => {
  return api.put(`${API_HISTORY_CULTURE}`, data);
};

const getCompany = () => {
  return api.get(`${API_COMPANY}`);
};

const updateCompany = (data) => {
  return api.put(`${API_COMPANY}`, data);
};

const getMedia = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEDIA_ACCREDITATION}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getMediaById = (id) => {
  return api.get(`${API_MEDIA_ACCREDITATION}/${id}`);
};

const deleteMediaById = (id) => {
  return api.delete(`${API_MEDIA_ACCREDITATION}/${id}`);
};

const updateMediaById = (id, req) => {
  return api.put(`${API_MEDIA_ACCREDITATION}/${id}`, req);
};

const getMediaTemplates = (type = null) => {
  function getType(type) {
    return type ? `/${type}` : "";
  }

  return api.get(`${API_MEDIA_TEMPLATE}${getType(type)}`);
};

const saveMediaTemplate = (type, data) => {
  return api.put(`${API_MEDIA_TEMPLATE}/${type}`, data);
};

const sendMediaEmailById = (id, type) => {
  return api.post(`${API_MEDIA_ACCREDITATION}/${id}/email?type=${type}`);
};

const getMediaConfig = () => {
  return api.get(`${API_MEDIA_ACCREDITATION}/configs/email/settings`);
};

const updateMediaConfig = (data) => {
  return api.put(`${API_MEDIA_ACCREDITATION}/configs/email/settings`, data);
};

const getRefundEvents = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_REFUND_FORM_PROGRAMMES}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getRefundEventById = (id) => {
  return api.get(`${API_REFUND_FORM_PROGRAMMES}/${id}`);
};

const updateRefundEventById = (id, req) => {
  return api.put(`${API_REFUND_FORM_PROGRAMMES}/${id}`, req);
};

const deleteRefundEventById = (id) => {
  return api.delete(`${API_REFUND_FORM_PROGRAMMES}/${id}`);
};

const postRefundEvent = (req) => {
  return api.post(`${API_REFUND_FORM_PROGRAMMES}`, req);
};

const orderRefundEvents = (req) => {
  return api.post(`${API_REFUND_FORM_PROGRAMMES}/seq`, req);
};

const getRefundVenues = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_REFUND_FORM_VENUES}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getRefundVenueById = (id) => {
  return api.get(`${API_REFUND_FORM_VENUES}/${id}`);
};

const updateRefundVenueById = (id, req) => {
  return api.put(`${API_REFUND_FORM_VENUES}/${id}`, req);
};

const deleteRefundVenueById = (id) => {
  return api.delete(`${API_REFUND_FORM_VENUES}/${id}`);
};

const postRefundVenue = (req) => {
  return api.post(`${API_REFUND_FORM_VENUES}`, req);
};

const orderRefundVenues = (req) => {
  return api.post(`${API_REFUND_FORM_VENUES}/seq`, req);
};

const getRefundEmailSettings = () => {
  return api.get(`${API_REFUND_FORM_EMAIL_CONFIG}`);
};

const updateRefundEmailSettings = (req) => {
  return api.put(`${API_REFUND_FORM_EMAIL_CONFIG}`, req);
};

const getRefundTNC = () => {
  return api.get(`${API_REFUND_FORM_TNC}`);
};

const updateRefundTNC = (req) => {
  return api.put(`${API_REFUND_FORM_TNC}`, req);
};

const getRefundAppForms = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_REFUND_FORM_APP}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getRefundAppFormById = (id) => {
  return api.get(`${API_REFUND_FORM_APP}/${id}`);
};

const updateRefundAppFormById = (id, req) => {
  return api.put(`${API_REFUND_FORM_APP}/${id}`, req);
};

const deleteRefundAppFormById = (id) => {
  return api.delete(`${API_REFUND_FORM_APP}/${id}`);
};

const getRefundFilmList = () => {
  return api.get(API_REFUND_FORM_FILM_LIST);
};

const importRefundFilmNames = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(API_REFUND_FORM_IMPORT_FILM_NAMES, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getBanners = (
  type,
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  function getStatus(status) {
    return status !== null ? `&status=${status}` : "";
  }

  function _getPageable(page, offset, pageSize) {
    return `?pageNumber=${page}&offset=${offset}&pageSize=${pageSize}`;
  }

  return api.get(
    `${API_HKIFF_BANNER}${getPageable(
      page,
      offset,
      pageSize
    )}&type=${type}${getKeyword(keyword)}${getStatus(status)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getBannerById = (id) => {
  return api.get(`${API_HKIFF_BANNER}/${id}`);
};

const createBanner = (req) => {
  return api.post(`${API_HKIFF_BANNER}`, req);
};

const updateBannerById = (id, req) => {
  return api.put(`${API_HKIFF_BANNER}/${id}`, req);
};

const deleteBannerById = (id) => {
  return api.delete(`${API_HKIFF_BANNER}/${id}`);
};

const updateBannerSeq = (array) => {
  return api.put(`${API_HKIFF_BANNER}/banner-order`, {
    bannerSequences: array,
  });
};

const getEDM = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_EDM}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getEDMById = (id) => {
  return api.get(`${API_HKIFF_EDM}/${id}`);
};

const createEDM = (req) => {
  return api.post(`${API_HKIFF_EDM}`, req);
};

const updateEDMById = (id, req) => {
  return api.put(`${API_HKIFF_EDM}/${id}`, req);
};

const deleteEDMById = (id) => {
  return api.delete(`${API_HKIFF_EDM}/${id}`);
};

const getFestival = (
  page = 0,
  offset = 0,
  size = 99999,
  type = "daily",
  hkiffId = 3,
  lang = "en"
) => {
  return api.get(
    `${API_HKIFF_FESTIVAL}${getPageable(
      page,
      offset,
      size
    )}&type=${type}&hkiffId=${hkiffId}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getFestivalById = (id) => {
  return api.get(`${API_HKIFF_FESTIVAL}/${id}`);
};

const createFestival = (req) => {
  return api.post(`${API_HKIFF_FESTIVAL}`, req);
};

const updateFestivalById = (id, req) => {
  return api.put(`${API_HKIFF_FESTIVAL}/${id}`, req);
};

const deleteFestivalById = (id) => {
  return api.delete(`${API_HKIFF_FESTIVAL}/${id}`);
};

const getSponsor = (
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }
  
  return api.get(
    `${API_HKIFF_SPONSOR}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`
  );
};

const getSponsorById = (id) => {
  return api.get(`${API_HKIFF_SPONSOR}/${id}`);
};

const createSponsor = (req) => {
  return api.post(`${API_HKIFF_SPONSOR}`, req);
};

const updateSponsorById = (id, req) => {
  return api.put(`${API_HKIFF_SPONSOR}/${id}`, req);
};

const deleteSponsorById = (id) => {
  return api.delete(`${API_HKIFF_SPONSOR}/${id}`);
};

const updateSponsorSeq = (id, array) => {
  return api.put(`${API_HKIFF_SPONSOR}/bulk/seq`, {
    categoryId: id,
    sequenceMap: array,
  });
};

const getSponsorsCategory = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_SPONSOR_CATEGORY}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getSponsorsCategoryById = (id) => {
  return api.get(`${API_HKIFF_SPONSOR_CATEGORY}/${id}`);
};

const createSponsorsCategory = (req) => {
  return api.post(`${API_HKIFF_SPONSOR_CATEGORY}`, req);
};

const updateSponsorsCategoryById = (id, req) => {
  return api.put(`${API_HKIFF_SPONSOR_CATEGORY}/${id}`, req);
};

const orderSponsorsCategories = (req) => {
  return api.put(`${API_HKIFF_SPONSOR_CATEGORY}/bulk/seq`, req);
};

const deleteSponsorsCategoryById = (id) => {
  return api.delete(`${API_HKIFF_SPONSOR_CATEGORY}/${id}`);
};

const getSubscriptions = (
  page = 0,
  offset = 0,
  pageSize = 999999,
) => {
  return api.get(
    `${API_HKIFF_SUBSCRIBE}${getPageable(
      page,
      offset,
      pageSize
    )}`
  );
};

const deleteSubscriptionById = (id) => {
  return api.delete(`${API_HKIFF_SUBSCRIBE}/${id}`);
};

const getEntriesApplications = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  submissionStatus = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getSubmissionStatus(status) {
    return status ? `&submissionStatus=${status}` : "";
  }

  return api.get(
    `${API_ENTRIES_APPLICATIONS}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${getSubmissionStatus(submissionStatus)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getEntriesApplicationById = (id) => {
  return api.get(`${API_ENTRIES_APPLICATIONS}/${id}`);
};

const updateEntriesApplicationById = (id, data) => {
  return api.put(`${API_ENTRIES_APPLICATIONS}/${id}`, data);
};

const sendApplicationEmail = (id, req) => {
  return api.post(`${API_ENTRIES_APPLICATIONS}/${id}/email`, req);
};

const getMembers = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERS}${getPageable(page, offset, pageSize)}
             ${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getMemberById = (id) => {
  return api.get(`${API_MEMBERS}/${id}`);
};

const updateMemberById = (id, data) => {
  return api.put(`${API_MEMBERS}/${id}`, data);
};

const updateMemberRecordById = (id, data) => {
  return api.post(`${API_ORDERS}/${id}`, data);
};

const deleteMemberById = (id) => {
  return api.delete(`${API_MEMBERS}/${id}`);
};

const getMemberPointHistory = (id) => {
  return api.get(`${API_MEMBERS}/${id}/point`);
};

const exportMemberPointHistory = (id) => {
  return api.get(`${API_MEMBERS}/${id}/point/export`, {
    responseType: 'blob'
  });
};

const resetPasswordEmail = (userId) => {
  return api.post(API_MEMBER_RESET_PASSWORD, { userId });
};

const sendMembershipEmailOtp = (email) => {
  return api.post(API_MEMBERSHIP_OTP_SEND, { email });
};

const verifyMembershipEmailOtp = (email, otpCode) => {
  return api.post(API_MEMBERSHIP_OTP_VERIFY, { email, otpCode });
};

const createWalkInMember = (data) => {
  return api.post(API_MEMBERSHIP_WALK_IN, data);
};

const getMembershipTnc = () => {
  return api.get(API_MEMBERSHIP_TNC);
};

const importMemberPoint = (formData) => {
  return api.post(`${API_MEMBERS}/excelImport/point`, formData);
};

const getConfig = () => {
  return api.get(API_HKIFF_CONFIG);
};

const saveConfig = (data) => {
  return api.put(API_HKIFF_CONFIG, data);
};

const getGifts = ({ keyword = null, page = 0, size = 10 }) => {
  let query = `?size=${size}&page=${page}`;
  query = keyword ? `${query}&keyword=${keyword}` : query;
  return api.get(`${API_GIFT}${query}`);
};

const getGiftById = (id) => {
  return api.get(`${API_GIFT}/${id}`);
};

const deleteGiftById = (id) => {
  return api.delete(`${API_GIFT}/${id}`);
};

const updateGiftById = (id, data) => {
  return api.put(`${API_GIFT}/${id}`, data);
};

const createGift = (data) => {
  return api.post(`${API_GIFT}`, data);
};

const getPlans = ({ keyword = null, page = 0, size = 10 }) => {
  let query = `?size=${size}&page=${page}`;
  query = keyword ? `${query}&keyword=${keyword}` : query;
  return api.get(`${API_PLAN}${query}`);
};

const getPlanById = (id) => {
  return api.get(`${API_PLAN}/${id}`);
};

const deletePlanById = (id) => {
  return api.delete(`${API_PLAN}/${id}`);
};

const updatePlanById = (id, data) => {
  return api.put(`${API_PLAN}/${id}`, data);
};

const createPlan = (data) => {
  return api.post(`${API_PLAN}`, data);
};

const getPlanFeature = () => {
  return api.get(`${API_PLAN}/feature`);
};

const getPlanFeatureById = (id) => {
  return api.get(`${API_PLAN}/feature/${id}`);
};

const createPlanFeature = (data) => {
  return api.post(`${API_PLAN}/feature`, data);
};

const updatePlanFeatureById = (id, data) => {
  return api.put(`${API_PLAN}/feature/${id}`, data);
};

const deletePlanFeatureById = (id) => {
  return api.delete(`${API_PLAN}/feature/${id}`);
};

const bulkUpdatePlanFeatureSequence = (data) => {
  return api.put(`${API_PLAN}/feature/bulk/seq`, data);
};

const getMembershipConfig = () => {
  return api.get(API_CONFIG);
};

const updateMembershipConfig = (data) => {
  return api.put(API_CONFIG, data);
};

const getMembershipEmailTemplate = () => {
  return api.get(API_EMAIL);
};

const updateMembershipEmailTemplate = (data) => {
  return api.put(API_EMAIL, data);
};

const getFestivalPass = (
    lang = "en",
    page = 0,
    offset = 0,
    pageSize = 10,
    keyword = null,
    unpaged = false
) => {
    function getKeyword(keyword) {
        return keyword ? `&keyword=${keyword}` : "";
    }

    function isUnpaged(unpaged) {
        return unpaged ? "&unpaged=true" : "";
    }

    return api.get(
        `${API_FESTIVAL_PASS}${getPageable(page, offset, pageSize)}${getKeyword(
            keyword
        )}${isUnpaged(unpaged)}`,
        {
            headers: {
                "Accept-Language": lang,
            },
        }
    );
};

const getFestivalPassById = (id) => {
    return api.get(`${API_FESTIVAL_PASS}/${id}`);
};

const updateFestivalPass = (data, id) => {
    return api.put(`${API_FESTIVAL_PASS}/${id}`, data);
};

const createFestivalPass = (data) => {
    return api.post(API_FESTIVAL_PASS, data);
}

const deleteFestivalPassById = (id) => {
    return api.delete(`${API_FESTIVAL_PASS}/${id}`);
}

const updateFestivalPassSeq = (array) => {
  return api.put(`${API_FESTIVAL_PASS}/sequence`, {
    sequenceList: array,
  });
};

const getTicketing = ({
                          keyword = null,
                          page = 0,
                          size = 10
                      }) => {
    let query = `&size=${size}&page=${page}`;
    query = keyword ? `${query}&keyword=${keyword}` : query;
    return api.get(`${API_TICKETING}?type=filmTicketInfo${query}`);
};

const getTicketingById = (id) => {
  return api.get(`${API_TICKETING}/${id}`);
};

const createTicketing = (data) => {
  return api.post(API_TICKETING, {
    ...data,
    type: "filmTicketInfo",
  });
};

const updateTicketing = (id, data) => {
  return api.put(`${API_TICKETING}/${id}`, {
    ...data,
    type: "filmTicketInfo",
  });
};

const deleteTicketing = (id) => {
  return api.delete(`${API_TICKETING}/${id}`);
};

const updateTicketingSeq = (array) => {
  return api.put(`${API_TICKETING}/sequence`, {
    sequenceList: array,
  });
};

const getFilmCategories = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  return api.get(
    `${API_FILM_CATEGORY}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getFilmCategoryById = (id) => {
  return api.get(`${API_FILM_CATEGORY}/${id}`);
};

const createFilmCategory = (data) => {
  return api.post(API_FILM_CATEGORY, data);
};

const updateFilmCategoryById = (id, data) => {
  return api.put(`${API_FILM_CATEGORY}/${id}`, data);
};

const deleteFilmCategoryById = (id) => {
  return api.delete(`${API_FILM_CATEGORY}/${id}`);
};

const orderFilmCategories = (data) => {
  return api.put(`${API_FILM_CATEGORY}/bulk/seq`, data);
};

const orderFilmSubCategories = (data) => {
  return api.put(`${API_FILM_SUBCATEGORY}/bulk/seq`, data);
};

const getFilmSubCategories = (
  categoryId = undefined,
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getCategoryId(categoryId) {
    return categoryId ? `&categoryId=${categoryId}` : "";
  }

  return api.get(
    `${API_FILM_SUBCATEGORY}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getCategoryId(categoryId)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getFilmSubCategoryById = (id) => {
  return api.get(`${API_FILM_SUBCATEGORY}/${id}`);
};

const createFilmSubCategory = (data) => {
  return api.post(API_FILM_SUBCATEGORY, data);
};

const updateFilmSubCategoryById = (id, data) => {
  return api.put(`${API_FILM_SUBCATEGORY}/${id}`, data);
};

const deleteFilmSubCategoryById = (id) => {
  return api.delete(`${API_FILM_SUBCATEGORY}/${id}`);
};

const getFilmListing = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false,
}) => {
  function getStatus(status) {
    return status === 0 || status === 1 ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_FILM}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`
  );
};

const getFilmById = (id) => {
  return api.get(`${API_FILM}/${id}`);
};

const deleteFilmById = (id) => {
  return api.delete(`${API_FILM}/${id}`);
};

const updateFilmById = (id, data) => {
  return api.put(`${API_FILM}/${id}`, data);
};

const createFilm = (data) => {
  return api.post(API_FILM, data);
};

const orderFilmListing = (data) => {
  return api.put(`${API_FILM}/bulk/seq`, data);
};

const importFilm = (data) => {
  return api.post(API_FILM_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const importFilmImage = (data) => {
  return api.post(API_FILM_IMPORT_IMAGE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getFilmTags = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_FILM_TAG}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getFilmTagById = (id) => {
  return api.get(`${API_FILM_TAG}/${id}`);
};

const updateFilmTagById = (id, data) => {
  return api.put(`${API_FILM_TAG}/${id}`, data);
};

const deleteFilmTagById = (id) => {
  return api.delete(`${API_FILM_TAG}/${id}`);
};

const bulkDeleteFilmTags = (ids) => {
  return api.delete(`${API_FILM_TAG}/bulk`, { data: { ids } });
};

const postFilmTag = (data) => {
  return api.post(API_FILM_TAG, data);
};

const orderFilmTags = (data) => {
  return api.put(`${API_FILM_TAG}/bulk/seq`, data);
}

const getFilmIcons = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_FILM_ICON}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const getFilmIconById = (id) => {
  return api.get(`${API_FILM_ICON}/${id}`);
};

const updateFilmIconById = (id, data) => {
  return api.put(`${API_FILM_ICON}/${id}`, data);
};

const deleteFilmIconById = (id) => {
  return api.delete(`${API_FILM_ICON}/${id}`);
};

const orderFilmIcons = (data) => {
  return api.put(`${API_FILM_ICON}/bulk/seq`, data);
};

const postFilmIcon = (data) => {
  return api.post(API_FILM_ICON, data);
};

const getFilmIconNameList = () => {
  return api.get(`${API_FILM_ICON}/namelist`);
};

const getFaq = ({ keyword = null, page = 0, size = 10 }) => {
  let query = `&size=${size}&page=${page}`;
  query = keyword ? `${query}&keyword=${keyword}` : query;
  return api.get(`${API_TICKETING}?type=faq${query}`);
};

const getFaqById = (id) => getTicketingById(id);

const createFaq = (data) => {
  return api.post(API_TICKETING, { ...data, type: "faq" });
};

const updateFaq = (id, data) => {
  return api.put(`${API_TICKETING}/${id}`, {
    ...data,
    type: "faq",
  });
};

const deleteFaq = (id) => deleteTicketing(id);

const updateFaqSeq = (array) => {
  return api.put(`${API_TICKETING}/sequence`, {
    sequenceList: array,
  });
};

const getJury = (
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null,
  unpaged = false
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_JURY}${getPageable(page, offset, pageSize)}${getStatus(
      status
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`
  );
};

const getJuryById = (id) => {
  return api.get(`${API_JURY}/${id}`);
};

const createJury = (data) => {
  return api.post(API_JURY, data);
};

const updateJuryById = (id, data) => {
  return api.put(`${API_JURY}/${id}`, data);
};

const deleteJury = (id) => {
  return api.delete(`${API_JURY}/${id}`);
};

const orderJury = (data) => {
  return api.put(`${API_JURY}/bulk/seq`, data);
};

const getAwardCategory = (
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null,
  unpaged = false
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_AWARD_CATEGORY}${getPageable(
      page,
      offset,
      pageSize
    )}${getStatus(status)}${getKeyword(keyword)}${isUnpaged(unpaged)}`
  );
};

const deleteAwardCategory = (id) => {
  return api.delete(`${API_HKIFF_AWARD_CATEGORY}/${id}`);
};

const getTemplate = () => {
  return api.get(API_HKIFF_TEMPLATE);
};

const getPrefillTemplate = (id) => {
  return api.get(`${API_ENTRIES_APPLICATIONS}/${id}/email`);
};

const saveTemplate = (data) => {
  return api.put(API_HKIFF_TEMPLATE, data);
};

const deleteEntryApplication = (id) => {
  return api.delete(`${API_ENTRIES_APPLICATIONS}/${id}`);
};

const getHkiffMenu = () => {
  return api.get(`${API_HKIFF_MENU}`);
};

const updateHkiffMenus = (data) => {
  return api.put(`${API_HKIFF_MENU}`, data);
};

const getHkiffMenuById = (id) => {
  return api.get(`${API_HKIFF_MENU}/${id}`);
};

const updateHkiffMenuById = (id, data) => {
  return api.put(`${API_HKIFF_MENU}/${id}`, data);
};

const getHkiffApp = (category) => {
  return api.get(API_HKIFF_APP(category));
};

const updateHkiffApp = (category, data) => {
  return api.put(API_HKIFF_APP(category), data);
};

const deleteHkiffApp = (category) => {
  return api.delete(API_HKIFF_APP(category));
};

const getHkiffAppMenu = () => {
  return api.get(API_HKIFF_APP_MENU);
};

const updateHkiffAppMenuOrder = (data) => {
  return api.put(`${API_HKIFF_APP_MENU}/order`, data);
};

const getHkiffAppMenuById = (id) => {
  return api.get(`${API_HKIFF_APP_MENU}/${id}`);
};

const updateHkiffAppMenuById = (data) => {
  return api.put(`${API_HKIFF_APP_MENU}`, data);
};

const getHkiffAppBanners = (
  type,
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  function getStatus(status) {
    return status !== null ? `&status=${status}` : "";
  }

  function _getPageable(page, offset, pageSize) {
    return `?pageNumber=${page}&offset=${offset}&pageSize=${pageSize}`;
  }

  return api.get(
    `${API_HKIFF_APP_BANNER}${getPageable(
      page,
      offset,
      pageSize
    )}&type=${type}${getKeyword(keyword)}${getStatus(status)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getHkiffAppBannerById = (id) => {
  return api.get(`${API_HKIFF_APP_BANNER}/${id}`);
};

const createHkiffAppBanner = (req) => {
  return api.post(`${API_HKIFF_APP_BANNER}`, req);
};

const updateHkiffAppBannerById = (id, req) => {
  return api.put(`${API_HKIFF_APP_BANNER}/${id}`, req);
};

const deleteHkiffAppBannerById = (id) => {
  return api.delete(`${API_HKIFF_APP_BANNER}/${id}`);
};

const getHkiffVenue = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
}) => {
  return api.get(
    `${API_HKIFF_VENUE}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const createHkiffNews = (data) => {
  return api.post(`${API_HKIFF_NEWS}`, data);
};

const getReports = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_REPORT}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getReportById = (id) => {
  return api.get(`${API_HKIFF_REPORT}/${id}`);
};

const updateReportById = (id, req) => {
  return api.put(`${API_HKIFF_REPORT}/${id}`, req);
};

const deleteReportById = (id) => {
  return api.delete(`${API_HKIFF_REPORT}/${id}`);
};

const postReport = (req) => {
  return api.post(`${API_HKIFF_REPORT}`, req);
};

const orderReports = (req) => {
  return api.put(`${API_HKIFF_REPORT}/bulk/seq`, req);
};

//HKNT
const getHkiffNews = (type = "", status = "", page = 0, offset = 0,  pageSize = 10, keyword = null) => {
  function getType(type) {
    return type ? `&type=${type}` : "";
  }
  
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  return api.get(`${API_HKIFF_NEWS}${`?page=${page}&offset=${offset}&size=${pageSize}`}${getType(type)}${getStatus(status)}${getKeyword(keyword)}`);
};

const updateHkiffNews = (data) => {
  return api.put(`${API_HKIFF_NEWS}`, data);
};

const getHkiffNewsById = (id) => {
  return api.get(`${API_HKIFF_NEWS}/${id}`);
};

const updateHkiffNewsById = (id, data) => {
  return api.put(`${API_HKIFF_NEWS}/${id}`, data);
};

const deleteHkiffNewsById = (id, data) => {
  return api.delete(`${API_HKIFF_NEWS}/${id}`, data);
};

const bulkUpdateHkiffNewsSequence = (bulkUpdateSeqRequest) => {
  return api.put(API_HKIFF_NEWS_BULK_SEQ, bulkUpdateSeqRequest);
};

const getPageWordByType = (type = null, keyword = null) => {
  function getType(type) {
    return type ? `?type=${type}` : "";
  }
  function getKeyword(type, keyword) {
    return keyword ? (type ? "&" : "?") + `keyword=${keyword}` : "";
  }
  return api.get(`${API_HKIFF_PAGE_WORD}${getType(type)}${getKeyword(type,keyword)}`);
};

const getPageWordById = (id) => {
  return api.get(`${API_HKIFF_PAGE_WORD}/${id}`);
};

const updatePageWordById = (id, data) => {
  return api.put(`${API_HKIFF_PAGE_WORD}/${id}`, data);
};

const listRegion = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_REGION}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getAllRegions = (data) => {
  return api.get(`${API_HKIFF_REGION}/allRegions`);
};

const getRegionById = (id) => {
  return api.get(`${API_HKIFF_REGION}/${id}`);
};

const updateRegionById = (id, data) => {
  return api.put(`${API_HKIFF_REGION}/${id}`, data);
};

const createRegion = (data) => {
  return api.post(`${API_HKIFF_REGION}`, data);
};

const deleteRegionById = (id, data) => {
  return api.delete(`${API_HKIFF_REGION}/${id}`, data);
};

const bulkDeleteRegion = (ids) => {
  return api.delete(`${API_HKIFF_REGION}/bulk`, { data: { ids } });
};

const updateRegionSequence = (bulkUpdateSeqRequest) => {
  return api.put(`${API_HKIFF_REGION}/sequence`, bulkUpdateSeqRequest);
};

const createDistrict = (data) => {
  return api.post(`${API_HKIFF_DISTRICT}`, data);
};

const listDistrict = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_DISTRICT}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getAllDistricts = (data) => {
  return api.get(`${API_HKIFF_DISTRICT}/allDistrict`);
};

const getDistrictById = (id) => {
  return api.get(`${API_HKIFF_DISTRICT}/${id}`);
};

const updateDistrictById = (id, data) => {
  return api.put(`${API_HKIFF_DISTRICT}/${id}`, data);
};

const deleteDistrictById = (id, data) => {
  return api.delete(`${API_HKIFF_DISTRICT}/${id}`, data);
};

const bulkDeleteDistrict = (ids) => {
  return api.delete(`${API_HKIFF_DISTRICT}/bulk`, { data: { ids } });
};

const createVenue = (data) => {
  return api.post(`${API_HKIFF_VENUE}`, data);
};

const updateDistrictSequence = (bulkUpdateSeqRequest) => {
  return api.put(`${API_HKIFF_DISTRICT}/sequence`, bulkUpdateSeqRequest);
};

const listVenue = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_VENUE}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getVenueById = (id) => {
  return api.get(`${API_HKIFF_VENUE}/${id}`);
};

const updateVenueById = (id, data) => {
  return api.put(`${API_HKIFF_VENUE}/${id}`, data);
};

const deleteVenueById = (id, data) => {
  return api.delete(`${API_HKIFF_VENUE}/${id}`, data);
};

const bulkDeleteVenue = (ids) => {
  return api.delete(`${API_HKIFF_VENUE}/bulk`, { data: { ids } });
};

const updateVenueSequence = (bulkUpdateSeqRequest) => {
  return api.put(`${API_HKIFF_VENUE}/sequence`, bulkUpdateSeqRequest);
};

const getProductCategories = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_PRODUCT_CATEGORY}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getProductCategoryById = (id) => {
  return api.get(`${API_HKIFF_PRODUCT_CATEGORY}/${id}`);
};

const updateProductCategoryById = (id, req) => {
  return api.put(`${API_HKIFF_PRODUCT_CATEGORY}/${id}`, req);
};

const deleteProductCategoryById = (id) => {
  return api.delete(`${API_HKIFF_PRODUCT_CATEGORY}/${id}`);
};

const postProductCategory = (req) => {
  return api.post(`${API_HKIFF_PRODUCT_CATEGORY}`, req);
};

const orderProductCategories = (req) => {
  return api.put(`${API_HKIFF_PRODUCT_CATEGORY}/bulk/seq`, req);
};

const getProducts = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_PRODUCT}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getProductById = (id) => {
  return api.get(`${API_HKIFF_PRODUCT}/${id}`);
};

const updateProductById = (id, req) => {
  return api.put(`${API_HKIFF_PRODUCT}/${id}`, req);
};

const deleteProductById = (id) => {
  return api.delete(`${API_HKIFF_PRODUCT}/${id}`);
};

const updateProductSeq = (array) => {
  return api.put(`${API_HKIFF_PRODUCT}/sequence`, {
    sequenceList: array,
  });
};

const createProduct = (req) => {
  return api.post(`${API_HKIFF_PRODUCT}`, req);
};

const getProductDiscount = (id) => {
  return api.get(`${API_HKIFF_PRODUCT}/membership-discount`);
};

const updateProductDiscount = (id, req) => {
  return api.put(`${API_HKIFF_PRODUCT}/membership-discount`, req);
};

const getProductTags = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_PRODUCT_TAG}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}&type=product`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getProductTagById = (id) => {
  return api.get(`${API_HKIFF_PRODUCT_TAG}/${id}`);
};

const updateProductTagById = (id, req) => {
  return api.put(`${API_HKIFF_PRODUCT_TAG}/${id}`, req);
};

const deleteProductTagById = (id) => {
  return api.delete(`${API_HKIFF_PRODUCT_TAG}/${id}`);
};

const postProductTag = (req) => {
  return api.post(`${API_HKIFF_PRODUCT_TAG}`, req);
};

const bulkDeleteProductTags = (ids) => {
  return api.delete(`${API_HKIFF_PRODUCT_TAG}/bulk/delete`, { data: { ids } });
};

const orderProductTags = (req) => {
  return api.put(`${API_HKIFF_PRODUCT_TAG}/bulk/seq`, req);
};

const getTransaction = (
  page = 0,
  offset = 0,
  keyword = null,
  unpaged = true
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_TRANSACTION}${getPageable(page, offset)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`
  );
};

const getTransactionById = (id) => {
  return api.get(`${API_HKIFF_TRANSACTION}/${id}`);
};

const updateTransactionById = (id, req) => {
  return api.put(`${API_HKIFF_TRANSACTION}/${id}`, req);
};

const getTransactionOrderStatus = () => {
  return api.get(`${API_HKIFF_TRANSACTION_ORDER_STATUS}`);
};

const getTransactionEmail = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  unpaged = false
) => {
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }
  return api.get(
    `${API_HKIFF_TRANSACTION_EMAIL}${getPageable(
      page,
      offset,
      pageSize
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getTransactionEmailById = (id) => {
  return api.get(`${API_HKIFF_TRANSACTION_EMAIL}/${id}`);
};

const updateTransactionEmailById = (id, data) => {
  return api.put(`${API_HKIFF_TRANSACTION_EMAIL}/${id}`, data);
};

const getShopOrders = (
  page = 0,
  offset = 0,
  keyword = null,
  productType = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getProductType(productType) {
    return productType ? `&productType=${productType}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_SHOP}${getPageable(page, offset)}${getKeyword(
      keyword
    )}${getProductType(productType)}${isUnpaged(unpaged)}`
  );
};

const getShopOrderById = (id) => {
  return api.get(`${API_MEMBERSHIP_SHOP}/${id}`);
};

const getVouchers = (
  page = 0,
  offset = 0,
  keyword = null,
  unpaged = false
) => {
  // function getKeyword(keyword) {
  //   return keyword ? `&keyword=${keyword}` : "";
  // }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_VOUCHER}${getPageable(page, offset)}${isUnpaged(unpaged)}`
  );
};

const getVoucherById = (id) => {
  return api.get(`${API_MEMBERSHIP_VOUCHER}/${id}`);
};

const createVoucherTemplate = (voucherData) => {
  return api.post(API_MEMBERSHIP_VOUCHER, voucherData);
};

const updateVoucherTemplate = (id, voucherData) => {
  return api.put(`${API_MEMBERSHIP_VOUCHER}/${id}`, voucherData);
};

const deleteVoucherTemplate = (id) => {
  return api.delete(`${API_MEMBERSHIP_VOUCHER}/${id}`);
};

const uploadVoucherImage = (voucherId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  return api.post(`${API_MEMBERSHIP_VOUCHER_IMPORT_IMAGE}/${voucherId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const updateProductVoucher = (id, data) => {
  return api.put(API_MEMBERSHIP_VOUCHER_PRODUCT(id), data);
};

const updateProductPromo = (id, data) => {
  return api.put(API_MEMBERSHIP_COUPON_PRODUCT(id), data);
};

const getPromoTemplates = (
  page = 0,
  offset = 0,
  pageSize = 10,
  unpaged = false
) => {
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_SHOP_COUPONS}${getPageable(page, offset, pageSize)}${isUnpaged(unpaged)}`
  );
};

const getPromoTemplateById = (id) => {
  return api.get(`${API_MEMBERSHIP_SHOP_COUPONS}/${id}`);
};

const createPromoTemplate = (data) => {
  return api.post(API_MEMBERSHIP_SHOP_COUPONS, data);
};

const updatePromoTemplate = (id, data) => {
  return api.put(`${API_MEMBERSHIP_SHOP_COUPONS}/${id}`, data);
};

const deletePromoTemplate = (id) => {
  return api.delete(`${API_MEMBERSHIP_SHOP_COUPONS}/${id}`);
};

const importCoupons = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return api.post(`${API_MEMBERSHIP_SHOP_COUPONS}/import/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const getMerchandise = (
  page = 0,
  offset = 0,
  pageSize = 10,
  unpaged = false
) => {
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_SHOP_MERCHANDISE}${getPageable(page, offset, pageSize)}${isUnpaged(unpaged)}`
  );
};

const getMerchandiseById = (id) => {
  return api.get(API_MEMBERSHIP_SHOP_MERCHANDISE_BY_ID(id));
};

const createMerchandise = (data) => {
  return api.post(API_MEMBERSHIP_SHOP_MERCHANDISE, data);
};

const updateMerchandise = (id, data) => {
  return api.put(API_MEMBERSHIP_SHOP_MERCHANDISE_BY_ID(id), data);
};

const deleteMerchandise = (id) => {
  return api.delete(API_MEMBERSHIP_SHOP_MERCHANDISE_BY_ID(id));
};

const getMembershipNews = (
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_NEWS}${getPageable(page, offset, pageSize)}${getKeyword(keyword)}${isUnpaged(unpaged)}`
  );
};

const getMembershipNewsById = (id) => {
  return api.get(API_MEMBERSHIP_NEWS_BY_ID(id));
};

const createMembershipNews = (data) => {
  return api.post(API_MEMBERSHIP_NEWS, data);
};

const updateMembershipNews = (id, data) => {
  return api.put(API_MEMBERSHIP_NEWS_BY_ID(id), data);
};

const deleteMembershipNews = (id) => {
  return api.delete(API_MEMBERSHIP_NEWS_BY_ID(id));
};

const getMembershipFaq = () => {
  return api.get(API_MEMBERSHIP_FAQ);
};

const getMembershipFaqById = (id) => {
  return api.get(API_MEMBERSHIP_FAQ_BY_ID(id));
};

const createMembershipFaq = (data) => {
  return api.post(API_MEMBERSHIP_FAQ, data);
};

const updateMembershipFaq = (id, data) => {
  return api.put(API_MEMBERSHIP_FAQ_BY_ID(id), data);
};

const deleteMembershipFaq = (id) => {
  return api.delete(API_MEMBERSHIP_FAQ_BY_ID(id));
};

const bulkUpdateMembershipFaqSequence = (data) => {
  return api.put(API_MEMBERSHIP_FAQ_BULK_SEQ, data);
};

const getMembershipFaqCategory = () => {
  return api.get(API_MEMBERSHIP_FAQ_CATEGORY);
};

const createMembershipFaqCategory = (data) => {
  return api.post(API_MEMBERSHIP_FAQ_CATEGORY, data);
};

const getMembershipFaqCategoryById = (id) => {
  return api.get(API_MEMBERSHIP_FAQ_CATEGORY_BY_ID(id));
};

const updateMembershipFaqCategory = (id, data) => {
  return api.put(API_MEMBERSHIP_FAQ_CATEGORY_BY_ID(id), data);
};

const deleteMembershipFaqCategory = (id) => {
  return api.delete(API_MEMBERSHIP_FAQ_CATEGORY_BY_ID(id));
};

const bulkUpdateMembershipFaqCategorySequence = (data) => {
  return api.put(API_MEMBERSHIP_FAQ_CATEGORY_BULK_SEQ, data);
};

const getHomepageBanners = (
  keyword = null,
  page = 0,
  offset = 0,
  pageSize = 10,
  unpaged = false
) => {
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_HOMEPAGE_BANNERS}${getPageable(page, offset, pageSize)}${getKeyword(keyword)}${isUnpaged(unpaged)}`
  );
};

const createHomepageBanner = (data) => {
  return api.post(API_MEMBERSHIP_HOMEPAGE_BANNERS, data);
};

const getHomepageBannerById = (id) => {
  return api.get(`${API_MEMBERSHIP_HOMEPAGE_BANNERS}/${id}`);
};

const updateHomepageBanner = (id, data) => {
  return api.put(`${API_MEMBERSHIP_HOMEPAGE_BANNERS}/${id}`, data);
};

const deleteHomepageBanner = (id) => {
  return api.delete(`${API_MEMBERSHIP_HOMEPAGE_BANNERS}/${id}`);
};

const bulkUpdateHomepageBannerSequence = (data) => {
  return api.put(`${API_MEMBERSHIP_HOMEPAGE_BANNERS}/bulk/seq`, data);
};

const getPartners = (
  keyword = null,
  page = 0,
  offset = 0,
  pageSize = 10,
  unpaged = false
) => {
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_MEMBERSHIP_HOMEPAGE_PARTNERS}${getPageable(page, offset, pageSize)}${getKeyword(keyword)}${isUnpaged(unpaged)}`
  );
};

const createPartner = (data) => {
  return api.post(API_MEMBERSHIP_HOMEPAGE_PARTNERS, data);
};

const getPartnerById = (id) => {
  return api.get(`${API_MEMBERSHIP_HOMEPAGE_PARTNERS}/${id}`);
};

const updatePartner = (id, data) => {
  return api.put(`${API_MEMBERSHIP_HOMEPAGE_PARTNERS}/${id}`, data);
};

const deletePartner = (id) => {
  return api.delete(`${API_MEMBERSHIP_HOMEPAGE_PARTNERS}/${id}`);
};

const bulkUpdatePartnerSequence = (data) => {
  return api.put(`${API_MEMBERSHIP_HOMEPAGE_PARTNERS}/bulk/seq`, data);
};

const uploadMembershipFile = (imageFile, folder) => {
  let bodyFormData = new FormData();
  bodyFormData.append("uploadFile", imageFile);

  return api.post(
    folder ? API_MEMBERSHIP_UPLOAD(folder) : API_MEMBERSHIP_UPLOAD(),
    bodyFormData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

const getJobSettings = () => {
  return api.get(`${API_HKIFF_JOB}/setting`);
};

const getJobSettingById = (id) => {
  return api.get(`${API_HKIFF_JOB}/setting/${id}`);
};

const updateJobSettingById = (id, data) => {
  return api.put(`${API_HKIFF_JOB}/setting/${id}`, data);
};

const getHkiffProgrammes = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_PROGRAMME}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getHkiffProgrammeById = (id) => {
  return api.get(`${API_HKIFF_PROGRAMME}/${id}`);
};

const updateHkiffProgrammeById = (id, req) => {
  return api.put(`${API_HKIFF_PROGRAMME}/${id}`, req);
};

const deleteHkiffProgrammeById = (id) => {
  return api.delete(`${API_HKIFF_PROGRAMME}/${id}`);
};

const bulkDeleteHkiffProgrammes = (ids) => {
  return api.delete(`${API_HKIFF_PROGRAMME}/bulk/delete`, { data: { ids } });
};

const createHkiffProgramme = (req) => {
  return api.post(`${API_HKIFF_PROGRAMME}`, req);
};

const getProgrammeCategories = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_PROGRAMME_CATEGORY}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getProgrammeCategoryById = (id) => {
  return api.get(`${API_HKIFF_PROGRAMME_CATEGORY}/${id}`);
};

const updateProgrammeCategoryById = (id, req) => {
  return api.put(`${API_HKIFF_PROGRAMME_CATEGORY}/${id}`, req);
};

const deleteProgrammeCategoryById = (id) => {
  return api.delete(`${API_HKIFF_PROGRAMME_CATEGORY}/${id}`);
};

const postProgrammeCategory = (req) => {
  return api.post(`${API_HKIFF_PROGRAMME_CATEGORY}`, req);
};

const orderProgrammeCategories = (req) => {
  return api.put(`${API_HKIFF_PROGRAMME_CATEGORY}/bulk/seq`, req);
};

const getProgrammeScreeningCodeById = (filmId) => {
  return api.get(`${API_HKIFF_PROGRAMME_SCREENING_CODE}?filmId=${filmId}`);
};

const getProgrammeType = (filmId) => {
  return api.get(`${API_HKIFF_PROGRAMME_TYPE}`);
};

const getAwardCategoryById = (id) => {
  return api.get(`${API_HKIFF_AWARD_CATEGORY}/${id}`);
};

const updateAwardCategoryById = (id, data) => {
  return api.put(`${API_HKIFF_AWARD_CATEGORY}/${id}`, data);
};

const deleteAwardCategoryById = (id, data) => {
  return api.delete(`${API_HKIFF_AWARD_CATEGORY}/${id}`);
};

const createAwardCategory = (data) => {
  return api.post(`${API_HKIFF_AWARD_CATEGORY}`, data);
};

const orderAwardCategory = (data) => {
  return api.put(`${API_HKIFF_AWARD_CATEGORY}/bulk/seq`, data);
};

const getAwardListing = ({
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false,
}) => {
  function getStatus(status) {
    return status === 0 || status === 1 ? `&status=${status}` : "";
  }
  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_AWARD}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(status)}${isUnpaged(unpaged)}`
  );
};
const getAward = (id) => {
  return api.get(`${API_HKIFF_AWARD}/${id}`);
};

const deleteAward = (id) => {
  return api.delete(`${API_HKIFF_AWARD}/${id}`);
};

const createAward = (data) => {
  return api.post(`${API_HKIFF_AWARD}`, data);
};

const updateAward = (id, data) => {
  return api.put(`${API_HKIFF_AWARD}/${id}`, data);
};

const getJobs = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_JOB}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getJobById = (id) => {
  return api.get(`${API_HKIFF_JOB}/${id}`);
};

const updateJobById = (id, req) => {
  return api.put(`${API_HKIFF_JOB}/${id}`, req);
};

const deleteJobById = (id) => {
  return api.delete(`${API_HKIFF_JOB}/${id}`);
};

const postJob = (req) => {
  return api.post(`${API_HKIFF_JOB}`, req);
};

const orderJobs = (req) => {
  return api.put(`${API_HKIFF_JOB}/bulk/seq`, req);
};

const orderAward = (data) => {
  return api.put(`${API_HKIFF_AWARD}/bulk/seq`, data);
};
const getEventListing = ({
  keyword = null,
  status = null,
  page = 0,
  rowsPerPage = 10,
  categoryId = null,
}) => {
  function getStatus(status) {
    return status || status === 0 ? `&status=${status}` : "";
  }

  function getCategoryId(categoryId) {
    return categoryId ? `&categoryId=${categoryId}` : "";
  }

  return api.get(
    `${API_HKIFF_EVENT}${getPageable(page, 0, rowsPerPage)}${getKeyword(
      keyword
    )}${getStatus(status)}${getCategoryId(categoryId)}`
  );
};

const getEventById = (id) => {
  return api.get(`${API_HKIFF_EVENT}/${id}`);
};

const updateEventById = (id, data) => {
  return api.put(`${API_HKIFF_EVENT}/${id}`, data);
};

const updateEventSeq = (array) => {
  return api.put(`${API_HKIFF_EVENT}/sequence`, {
    sequenceList: array,
  });
};

const createEvent = (data) => {
  return api.post(`${API_HKIFF_EVENT}`, data);
};

const deleteEventById = (id) => {
  return api.delete(`${API_HKIFF_EVENT}/${id}`);
};

const getEventCategoryListing = ({
  keyword = null,
  status = null,
  page = 0,
  rowsPerPage = 10,
  unpaged = false,
}) => {
  function getStatus(status) {
    return status || status === false ? `&status=${status}` : "";
  }

  return unpaged
    ? api.get(`${API_HKIFF_EVENT_CATEGORY}?unpaged=true`)
    : api.get(
        `${API_HKIFF_EVENT_CATEGORY}${getPageable(
          page,
          0,
          rowsPerPage
        )}${getKeyword(keyword)}${getStatus(status)}`
      );
};

const getEventCategories = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_EVENT_CATEGORY}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getEventCategoryById = (id) => {
  return api.get(`${API_HKIFF_EVENT_CATEGORY}/${id}`);
};

const updateEventCategoryById = (id, req) => {
  return api.put(`${API_HKIFF_EVENT_CATEGORY}/${id}`, req);
};

const deleteEventCategoryById = (id) => {
  return api.delete(`${API_HKIFF_EVENT_CATEGORY}/${id}`);
};

const createEventCategory = (req) => {
  return api.post(`${API_HKIFF_EVENT_CATEGORY}`, req);
};

const orderEventCategories = (req) => {
  return api.put(`${API_HKIFF_EVENT_CATEGORY}/bulk/seq`, req);
};

const getLogoGroups = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_LOGO}/group${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getHkiff = (
  page = 0,
  offset = 0,
  size = 99999,
  type = "daily",
  hkiffId = 3,
  lang = "en"
) => {
  return api.get(
    `${API_HKIFF}${getPageable(
      page,
      offset,
      size
    )}&type=${type}&hkiffId=${hkiffId}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getLogoGroupById = (id) => {
  return api.get(`${API_HKIFF_LOGO}/group/${id}`);
};

const updateLogoGroupById = (id, req) => {
  return api.put(`${API_HKIFF_LOGO}/group/${id}`, req);
};

const deleteLogoGroupById = (id) => {
  return api.delete(`${API_HKIFF_LOGO}/group/${id}`);
};

const postLogoGroup = (req) => {
  return api.post(`${API_HKIFF_LOGO}/group`, req);
};

const orderLogoGroups = (req) => {
  return api.put(`${API_HKIFF_LOGO}/group/bulk/seq`, req);
};

const listGroupParent = () => {
  return api.get(`${API_HKIFF_LOGO}/group/parent`);
};
const importMember = (data) => {
  return api.post(API_MEMBER_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const importMemberOrder = (formData) => {
  return api.post(`${API_MEMBER_IMPORT_FILE}/order`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getLogoPage = () => {
  return api.get(`${API_HKIFF_LOGO}/page`);
};

const updateLogoPage = (req) => {
  return api.put(`${API_HKIFF_LOGO}/page`, req);
};

const getLogos = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_LOGO}/logo${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getLogoById = (id) => {
  return api.get(`${API_HKIFF_LOGO}/logo/${id}`);
};

const updateLogoById = (id, req) => {
  return api.put(`${API_HKIFF_LOGO}/logo/${id}`, req);
};

const deleteLogoById = (id) => {
  return api.delete(`${API_HKIFF_LOGO}/logo/${id}`);
};

const postLogo = (req) => {
  return api.post(`${API_HKIFF_LOGO}/logo`, req);
};

const orderLogos = (req) => {
  return api.put(`${API_HKIFF_LOGO}/logo/bulk/seq`, req);
};

const getHkiffById = (id) => {
  return api.get(`${API_HKIFF}/${id}`);
};

const createHkiff = (req) => {
  return api.post(`${API_HKIFF}`, req);
};

const updateHkiffById = (id, req) => {
  return api.put(`${API_HKIFF}/${id}`, req);
};

const deleteHkiffById = (id) => {
  return api.delete(`${API_HKIFF}/${id}`);
};

const getShippingCategories = () => {
    return api.get(`${API_SHIPPING}/category`);
  };

const getShippings = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  unpaged = false,
  status = null,
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_SHIPPING}${getPageable(
      page,
      offset,
      pageSize
    )}${getKeyword(keyword)}${getStatus(status)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getShippingById = (id) => {
  return api.get(`${API_SHIPPING}/${id}`);
};

const createShipping = (data) => {
  return api.post(API_SHIPPING, data);
};

const updateShippingById = (id, data) => {
  return api.put(`${API_SHIPPING}/${id}`, data);
};

const deleteShippingById = (id) => {
  return api.delete(`${API_SHIPPING}/${id}`);
};

const orderShippings = (data) => {
  return api.put(`${API_SHIPPING}/bulk/seq`, data);
};
const getEshopSetting = () => {
  return api.get(`${API_HKIFF_ESHOP}`);
};
const updateEshopSetting = (req) => {
  return api.put(`${API_HKIFF_ESHOP}`, req);
};


// aca

const getHkiffScoreBoard = () => {
  return api.get(
    `${API_HKIFF_SCORE_BOARD}`
  );
};

const getHkiffAcaFilmListing = ({
  keyword = null,
  page = 0,
  size = 10
}) => {
  let query = `&size=${size}&page=${page}`;
  query = keyword ? `${query}&keyword=${keyword}` : query;
  return api.get(
    `${API_HKIFF_ACA_FILM_LIST}?${query}`
  );
};

const importAcaFilm = (data) => {
  return api.post(API_ACA_FILM_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getHkiffAcaBannerListing = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  keyword = null,
  status = null,
  unpaged = false
) => {
  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKIFF_ACA_BANNER}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}${getStatus(
      status
    )}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const getHkiffAcaBanner = () => {
  return api.get(`${API_HKIFF_ACA_BANNER}`);
};

const getHkiffAcaBannerById = (id) => {
  return api.get(`${API_HKIFF_ACA_BANNER}/${id}`);
};

const createHkiffAcaBanner = (req) => {
  return api.post(`${API_HKIFF_ACA_BANNER}`, req);
};

const updateHkiffAcaBannerById = (id, req) => {
  return api.put(`${API_HKIFF_ACA_BANNER}/${id}`, req);
};

const deleteAcaBannerById = (id) => {
  return api.delete(`${API_HKIFF_ACA_BANNER}/${id}`);
};

const getAcaSetting = () => {
  return api.get(`${API_HKIFF_ACA_SETTING}`);
};

const updateAcaSetting = (req) => {
  return api.put(`${API_HKIFF_ACA_SETTING}`, req);
};

//HKNT
const hkntGetPages = (data) => {
  return api.get(API_HKNT_PAGES, { params: data });
};

const hkntGetPageById = (id) => {
  return api.get(`${API_HKNT_PAGES}/${id}`);
};

const hkntUpdatePageById = (id, data) => {
  return api.put(`${API_HKNT_PAGES}/${id}`, data);
};

const hkntDeletePage = (id) => {
  return api.delete(`${API_HKNT_PAGES}/${id}`);
};

const hkntCreatePage = (data) => {
  return api.post(API_HKNT_PAGES, data);
};

const hkntGetHomepage = () => {
  return api.get(API_HKNT_HOMEPAGE);
};

const hkntUpdateHomepage = (homepage) => {
  return api.put(API_HKNT_HOMEPAGE, homepage);
};

const hkntGetPagesByCategory = (category) => {
  return api.get(API_HKNT_GET_PAGE(category));
};

const hkntGetMovies = (
  lang = "en",
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null,
  date = null,
  unpaged = false
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  function isUnpaged(unpaged) {
    return unpaged ? "&unpaged=true" : "";
  }

  return api.get(
    `${API_HKNT_MOVIES}${getPageable(page, offset, pageSize)}${getStatus(
      status
    )}${getKeyword(keyword)}${getDate(date)}${isUnpaged(unpaged)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const hkntGetAllMovies = (
  lang = "en",
  status = null,
  keyword = null,
  date = null
) => {
  function getStatus(status) {
    return status ? `&status=${status}` : "";
  }

  function getKeyword(keyword) {
    return keyword ? `&keyword=${keyword}` : "";
  }

  function getDate(date) {
    return date ? `&date=${date}` : "";
  }

  return api.get(
    `${API_HKNT_MOVIES}?unpaged=true${getStatus(status)}${getKeyword(
      keyword
    )}${getDate(date)}`,
    {
      headers: {
        "Accept-Language": lang,
      },
    }
  );
};

const hkntGetMovieById = (id) => {
  return api.get(API_HKNT_MOVIE(id));
};

const hkntUpdateMovieById = (id, data) => {
  return api.put(API_HKNT_MOVIE(id), data);
};

const hkntCreateMovie = (data) => {
  return api.post(API_HKNT_MOVIES, data);
};

const hkntDeleteMovie = (id) => {
  return api.delete(API_HKNT_MOVIE(id));
};

const hkntGetAllRemarks = () => {
  return api.get(API_HKNT_REMARKS);
};

const hkntGetRemarkById = (id) => {
  return api.get(API_HKNT_REMARK(id));
};

const hkntUpdateRemarkById = (id, remark) => {
  return api.put(API_HKNT_REMARK(id), remark);
};

const hkntDeleteRemarkById = (id) => {
  return api.delete(API_HKNT_REMARK(id));
};

const hkntBulkDeleteRemarks = (ids) => {
  return api.delete(API_HKNT_REMARKS_BULK, {
    data: { ids: ids, status: "DELETED" },
  });
};

const hkntPostRemark = (remark) => {
  return api.post(API_HKNT_REMARKS, remark);
};

const hkntGetAllRotatingBanners = () => {
  return api.get(API_HKNT_ROTATING_BANNERS);
};

const hkntUpdateRotatingBannerById = (id, rotatingBanner) => {
  return api.put(API_HKNT_ROTATING_BANNER(id), rotatingBanner);
};

const hkntDeleteRotatingBannerById = (id) => {
  return api.delete(API_HKNT_ROTATING_BANNER(id));
};

const hkntPostRotatingBanner = (rotatingBanner) => {
  return api.post(API_HKNT_ROTATING_BANNERS, rotatingBanner);
};

const hkntGetAllTags = () => {
  return api.get(API_HKNT_TAGS);
};

const hkntGetTagById = (id) => {
  return api.get(API_HKNT_TAG(id));
};

const hkntDeleteTagById = (id) => {
  return api.delete(API_HKNT_TAG(id));
};

const hkntUpdateTagById = (id, tag) => {
  return api.put(API_HKNT_TAG(id), tag);
};

const hkntCreateTag = (tag) => {
  return api.post(API_HKNT_TAGS, tag);
};

const hkntBulkDeleteTags = (ids) => {
  return api.delete(API_HKNT_TAGS_BULK, { data: { ids } });
};

const hkntGetMovieNote = () => {
  return api.get(API_HKNT_NOTE);
};

const hkntUpdateMovieNote = (note) => {
  return api.put(API_HKNT_NOTE, note);
};

const hkntUploadFile = (imageFile) => {
  let bodyFormData = new FormData();
  bodyFormData.append("uploadImage", imageFile);

  return api.post(API_HKNT_UPLOAD, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const hkntGetPeriodList = (data) => {
  return api.get(API_HKNT_PERIOD, { params: data });
};

const hkntGetPeriodById = (id) => {
  return api.get(`${API_HKNT_PERIOD}/${id}`);
};

const hkntAddPeriod = (data) => {
  return api.post(API_HKNT_PERIOD, data);
};

const hkntUpdatePeriod = (id, data) => {
  return api.put(`${API_HKNT_PERIOD}/${id}`, data);
};

const hkntUpdatePeriodOrder = (data) => {
  return api.put(`${API_HKNT_PERIOD}/period-order`, { periodSequences: data });
};

const hkntDeletePeriod = (id) => {
  return api.delete(`${API_HKNT_PERIOD}/${id}`);
};

const hkntBulkDeletePeriod = (ids) => {
  return api.delete(`${API_HKNT_PERIOD_BULK}`, { data: { ids } });
};

const hkntGetParentPeriodList = () => {
  return api.get(API_HKNT_PARENT_PERIOD);
};

const hkntGetMenu = () => {
  return api.get(API_HKNT_MENU);
};

const hkntGetMenuById = (id) => {
  return api.get(`${API_HKNT_MENU}/${id}`);
};

const hkntUpdateMenu = (id, data) => {
  return api.put(`${API_HKNT_MENU}/${id}`, data);
};

const hkntGetProgrammes = (
  page = 0,
  offset = 0,
  pageSize = 10,
  status = null,
  keyword = null
) => {
  return api.get(
    `${API_HKNT_PROGRAMME}${getPageable(page, offset, pageSize)}${getKeyword(
      keyword
    )}`
  );
};

const hkntGetAllProgrammes = (lang = "en", keyword) => {
  return api.get(`${API_HKNT_PROGRAMME}?unpaged=true${getKeyword(keyword)}`);
};

const hkntCreateProgramme = (data) => {
  return api.post(API_HKNT_PROGRAMME, data);
};

const hkntGetProgrammeById = (id) => {
  return api.get(API_HKNT_PROGRAMMEBYID(id));
};

const hkntUpdpateProgrammeById = (id, data) => {
  return api.put(API_HKNT_PROGRAMMEBYID(id), data);
};

const hkntDeleteProgrammeById = (id) => {
  return api.delete(API_HKNT_PROGRAMMEBYID(id));
};

const hkntGetAllAdmins = () => {
  return api.get(API_HKNT_ADMIN);
};

const hkntGetAdminsById = (roleId) => {
  return api.get(`${API_HKNT_ADMIN}?roleId=${roleId}`);
};

const hkntAddAdmins = (data) => {
  return api.post(API_HKNT_ADMIN, data);
};

const hkntGetAdminsByRole = (role) => {
  return api.get(`${API_HKNT_ROLES}/${role}`);
};

const hkntGetAdminById = (id) => {
  return api.get(`${API_HKNT_ADMIN}/${id}`);
};

const hkntUpdateAdminById = (id, data) => {
  return api.put(`${API_HKNT_ADMIN}/${id}`, data);
};

const hkntGetRoles = () => {
  return api.get(API_HKNT_ROLES);
};

const hkntGetOptions = () => {
  return api.get(API_HKNT_OPTION);
};

const hkntUpdateOptions = (data) => {
  return api.put(API_HKNT_OPTION, data);
};

const hkntImportMovie = (data) => {
  return api.post(API_HKNT_MOVIE_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const hkntImportMovieImage = (data) => {
  return api.post(API_HKNT_MOVIE_IMPORT_IMAGE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const hkntImportPage = (data) => {
  return api.post(API_HKNT_PAGE_IMPORT_FILE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const hkntImportPageImage = (data) => {
  return api.post(API_HKNT_PAGE_IMPORT_IMAGE, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const apiHelper = {
  adminLogin,
  adminLogout,
  adminInfo,
  getAllAdmins,
  getAdminsById,
  cinefan: {
    getHomepage,
    updateHomepage,
    getPagesByCategory,
    getMovies,
    updateAdminInfo,
    getAllMovies,
    getMovieById,
    deleteMovie,
    bulkPublishMovies,
    updateMovieById,
    createMovie,
    getMovieNote,
    updateMovieNote,
    getAllRemarks,
    getRemarkById,
    updateRemarkById,
    deleteRemarkById,
    bulkDeleteRemarks,
    postRemark,
    getAllRotatingBanners,
    updateRotatingBannerById,
    deleteRotatingBannerById,
    postRotatingBanner,
    getAllTags,
    uploadFile,
    getTagById,
    deleteTagById,
    updateTagById,
    createTag,
    bulkDeleteTags,
    bulkUpdateTagSequence,
    getPages,
    getPageById,
    updatePageById,
    deletePage,
    createPage,
    getPeriodList,
    getPeriodById,
    addPeriod,
    updatePeriod,
    updatePeriodOrder,
    deletePeriod,
    bulkDeletePeriod,
    getParentPeriodList,
    getMenu,
    getMenuById,
    updateMenu,
    getProgrammes,
    getAllProgrammes,
    createProgramme,
    getProgrammeById,
    updpateProgrammeById,
    deleteProgrammeById,
    updateProgrammeSeq,
    addAdmins,
    getAdminsByRole,
    getAdminById,
    updateAdminById,
    getRoles,
    getOptions,
    updateOptions,
    importMovie,
    importMovieImage,
    importPage,
    importPageImage,
  },
  cineclub: {
    sendMembershipEmailOtp,
    verifyMembershipEmailOtp,
    createWalkInMember,
    getMembershipTnc,
    getShopOrders,
    getShopOrderById,
    getVouchers,
    getVoucherById,
    createVoucherTemplate,
    updateVoucherTemplate,
    deleteVoucherTemplate,
    uploadVoucherImage,
    updateProductVoucher,
    updateProductPromo,
    getPromoTemplates,
    getPromoTemplateById,
    createPromoTemplate,
    updatePromoTemplate,
    deletePromoTemplate,
    importCoupons,
    getMerchandise,
    getMerchandiseById,
    createMerchandise,
    updateMerchandise,
    deleteMerchandise,
    getHomepageBanners,
    createHomepageBanner,
    getHomepageBannerById,
    updateHomepageBanner,
    deleteHomepageBanner,
    bulkUpdateHomepageBannerSequence,
    getPartners,
    createPartner,
    getPartnerById,
    updatePartner,
    deletePartner,
    bulkUpdatePartnerSequence,
    uploadMembershipFile,
    getMembershipNews,
    getMembershipNewsById,
    createMembershipNews,
    updateMembershipNews,
    deleteMembershipNews,
    getMembershipFaq,
    getMembershipFaqById,
    createMembershipFaq,
    updateMembershipFaq,
    deleteMembershipFaq,
    bulkUpdateMembershipFaqSequence,
    getMembershipFaqCategory,
    createMembershipFaqCategory,
    getMembershipFaqCategoryById,
    updateMembershipFaqCategory,
    deleteMembershipFaqCategory,
    bulkUpdateMembershipFaqCategorySequence,
  },
  hkiff: {
    getBanners,
    getBannerById,
    createBanner,
    updateBannerById,
    deleteBannerById,
    updateBannerSeq,
    getEDM,
    getEDMById,
    createEDM,
    updateEDMById,
    deleteEDMById,
    getFestival,
    getFestivalById,
    createFestival,
    updateFestivalById,
    deleteFestivalById,
    getSponsor,
    getSponsorById,
    createSponsor,
    updateSponsorById,
    deleteSponsorById,
    updateSponsorSeq,
    getSponsorsCategory,
    getSponsorsCategoryById,
    createSponsorsCategory,
    updateSponsorsCategoryById,
    orderSponsorsCategories,
    deleteSponsorsCategoryById,
    getSubscriptions,
    deleteSubscriptionById,
    getInvitedEntries,
    getInvitedEntryById,
    getEntriesApplications,
    getEntriesApplicationById,
    updateEntriesApplicationById,
    getGuests,
    getGuestById,
    updateGuestById,
    deleteGuestById,
    getMedia,
    getMediaById,
    updateMediaById,
    deleteMediaById,
    sendApplicationEmail,
    getConfig,
    saveConfig,
    getTemplate,
    getPrefillTemplate,
    saveTemplate,
    deleteEntryApplication,
    getHkiffMenu,
    updateHkiffMenus,
    getHkiffMenuById,
    updateHkiffMenuById,
    createHkiffNews,
    getHkiffNews,
    updateHkiffNews,
    getHkiffNewsById,
    updateHkiffNewsById,
    deleteHkiffNewsById,
    bulkUpdateHkiffNewsSequence,
    getPageWordByType,
    getPageWordById,
    updatePageWordById,
    createRegion,
    listRegion,
    getAllRegions,
    getRegionById,
    updateRegionById,
    deleteRegionById,
    bulkDeleteRegion,
    updateRegionSequence,
    createDistrict,
    listDistrict,
    getAllDistricts,
    getDistrictById,
    updateDistrictById,
    deleteDistrictById,
    bulkDeleteDistrict,
    updateDistrictSequence,
    createVenue,
    listVenue,
    getVenueById,
    updateVenueById,
    deleteVenueById,
    bulkDeleteVenue,
    updateVenueSequence,
    getEventCategories,
    getEventCategoryById,
    updateEventCategoryById,
    deleteEventCategoryById,
    createEventCategory,
    orderEventCategories,
    importMember,
    getInvitedAccreditations,
    importInvitedAccreditations,
    sendInvitedAccreditationEmail,
    bulkDeleteInvitedAccreditations,
    getGuestTemplates,
    saveGuestTemplate,
    sendGuestEmailById,
    getGuestConfig,
    updateGuestConfig,
    getContactUs,
    updateContactUs,
    getSupportUsListing,
    createSupportUs,
    getSupportUsById,
    updateSupportUsById,
    deleteSupportUsById,
    orderSupportUsListing,
    getOrganizations,
    getOrganizationById,
    createOrganization,
    updateOrganizationById,
    deleteOrganizationById,
    updateOrganizationSeq,
    getPositions,
    getPositionById,
    createPosition,
    updatePositionById,
    updatePositionSeq,
    deletePositionById,
    getEmployees,
    getEmployeeById,
    createEmployee,
    updateEmployeeById,
    deleteEmployeeById,
    updateEmployeeSeq,
    getHistoryCulture,
    updateHistoryCulture,
    getCompany,
    updateCompany,
    getMediaTemplates,
    saveMediaTemplate,
    sendMediaEmailById,
    getMediaConfig,
    updateMediaConfig,
    getRefundEvents,
    getRefundEventById,
    updateRefundEventById,
    deleteRefundEventById,
    postRefundEvent,
    orderRefundEvents,
    getRefundVenues,
    getRefundVenueById,
    updateRefundVenueById,
    deleteRefundVenueById,
    postRefundVenue,
    orderRefundVenues,
    getRefundEmailSettings,
    updateRefundEmailSettings,
    getRefundTNC,
    updateRefundTNC,
    getRefundAppForms,
    getRefundAppFormById,
    updateRefundAppFormById,
    deleteRefundAppFormById,
    getRefundFilmList,
    importRefundFilmNames,
    uploadHKIFFFile,
    getMembers,
    getMemberById,
    updateMemberById,
    updateMemberRecordById,
    deleteMemberById,
    getMemberPointHistory,
    exportMemberPointHistory,
    resetPasswordEmail,
    importMemberPoint,
    importMemberOrder,
    getGifts,
    getGiftById,
    updateGiftById,
    deleteGiftById,
    createGift,
    getPlans,
    getPlanById,
    updatePlanById,
    deletePlanById,
    createPlan,
    getPlanFeature,
    getPlanFeatureById,
    createPlanFeature,
    updatePlanFeatureById,
    deletePlanFeatureById,
    bulkUpdatePlanFeatureSequence,
    getMembershipConfig,
    updateMembershipConfig,
    getMembershipEmailTemplate,
    updateMembershipEmailTemplate,
    getFestivalPass,
    getFestivalPassById,
    updateFestivalPass,
    createFestivalPass,
    deleteFestivalPassById,
    updateFestivalPassSeq,
    getTicketing,
    getTicketingById,
    createTicketing,
    updateTicketing,
    deleteTicketing,
    updateTicketingSeq,
    getFilmCategories,
    getFilmCategoryById,
    createFilmCategory,
    updateFilmCategoryById,
    deleteFilmCategoryById,
    getFilmSubCategories,
    getFilmSubCategoryById,
    orderFilmCategories,
    orderFilmSubCategories,
    createFilmSubCategory,
    updateFilmSubCategoryById,
    deleteFilmSubCategoryById,
    getFilmListing,
    deleteFilmById,
    orderFilmListing,
    getFaq,
    getFaqById,
    createFaq,
    updateFaq,
    deleteFaq,
    updateFaqSeq,
    getJobs,
    getJobById,
    updateJobById,
    deleteJobById,
    postJob,
    orderJobs,
    getFilmById,
    updateFilmById,
    createFilm,
    importFilm,
    importFilmImage,
    getFilmTags,
    getFilmTagById,
    updateFilmTagById,
    deleteFilmTagById,
    bulkDeleteFilmTags,
    postFilmTag,
    orderFilmTags,
    getFilmIcons,
    getFilmIconById,
    updateFilmIconById,
    deleteFilmIconById,
    orderFilmIcons,
    postFilmIcon,
    getFilmIconNameList,
    getHkiffVenue,
    getProductCategories,
    getProductCategoryById,
    updateProductCategoryById,
    deleteProductCategoryById,
    postProductCategory,
    orderProductCategories,
    getProducts,
    getProductById,
    updateProductById,
    deleteProductById,
    updateProductSeq,
    createProduct,
    getProductDiscount,
    updateProductDiscount,
    getProductTags,
    getProductTagById,
    updateProductTagById,
    deleteProductTagById,
    postProductTag,
    bulkDeleteProductTags,
    orderProductTags,
    getTransaction,
    getTransactionById,
    updateTransactionById,
    getTransactionOrderStatus,
    getTransactionEmail,
    getTransactionEmailById,
    updateTransactionEmailById,
    getHkiffProgrammes,
    getHkiffProgrammeById,
    updateHkiffProgrammeById,
    deleteHkiffProgrammeById,
    bulkDeleteHkiffProgrammes,
    createHkiffProgramme,
    getProgrammeCategories,
    getProgrammeCategoryById,
    updateProgrammeCategoryById,
    deleteProgrammeCategoryById,
    postProgrammeCategory,
    orderProgrammeCategories,
    getProgrammeScreeningCodeById,
    getProgrammeType,
    getAwardCategory,
    getAwardCategoryById,
    updateAwardCategoryById,
    deleteAwardCategoryById,
    createAwardCategory,
    orderAwardCategory,
    getAwardListing,
    deleteAward,
    getAward,
    createAward,
    updateAward,
    orderAward,
    getJury,
    getJuryById,
    createJury,
    updateJuryById,
    deleteJury,
    orderJury,
    deleteAwardCategory,
    getJobSettings,
    getJobSettingById,
    updateJobSettingById,
    getEventListing,
    getEventById,
    updateEventById,
    updateEventSeq,
    createEvent,
    deleteEventById,
    getEventCategoryListing,
    getLogoGroups,
    getLogoGroupById,
    updateLogoGroupById,
    deleteLogoGroupById,
    postLogoGroup,
    orderLogoGroups,
    listGroupParent,
    getLogoPage,
    updateLogoPage,
    getLogos,
    getLogoById,
    updateLogoById,
    deleteLogoById,
    postLogo,
    orderLogos,
    getReports,
    getReportById,
    updateReportById,
    deleteReportById,
    postReport,
    orderReports,
    getHkiff,
    getHkiffById,
    createHkiff,
    updateHkiffById,
    deleteHkiffById,
    getShippingCategories,
    getShippings,
    getShippingById,
    createShipping,
    updateShippingById,
    deleteShippingById,
    orderShippings,
    getEshopSetting,
    updateEshopSetting,
    getHkiffScoreBoard,
    getHkiffAcaFilmListing,
    getHkiffAcaBanner,
    getHkiffAcaBannerById,
    createHkiffAcaBanner,
    updateHkiffAcaBannerById,
    importAcaFilm,
    deleteAcaBannerById,
    getAcaSetting,
    updateAcaSetting,
  },
  hkiffApp: {
    getHkiffApp,
    updateHkiffApp,
    deleteHkiffApp,
    getHkiffAppMenu,
    updateHkiffAppMenuOrder,
    getHkiffAppMenuById,
    updateHkiffAppMenuById,
    getHkiffAppBanners,
    getHkiffAppBannerById,
    createHkiffAppBanner,
    updateHkiffAppBannerById,
    deleteHkiffAppBannerById,
  },
  hknt: {
    hkntGetPages,
    hkntGetPageById,
    hkntUpdatePageById,
    hkntDeletePage,
    hkntCreatePage,
    hkntGetHomepage,
    hkntUpdateHomepage,
    hkntGetPagesByCategory,
    hkntGetMovies,
    hkntGetAllMovies,
    hkntGetMovieById,
    hkntUpdateMovieById,
    hkntCreateMovie,
    hkntDeleteMovie,
    hkntGetAllRemarks,
    hkntGetRemarkById,
    hkntUpdateRemarkById,
    hkntDeleteRemarkById,
    hkntBulkDeleteRemarks,
    hkntPostRemark,
    hkntGetAllRotatingBanners,
    hkntUpdateRotatingBannerById,
    hkntDeleteRotatingBannerById,
    hkntPostRotatingBanner,
    hkntGetAllTags,
    hkntGetTagById,
    hkntDeleteTagById,
    hkntUpdateTagById,
    hkntCreateTag,
    hkntBulkDeleteTags,
    hkntGetMovieNote,
    hkntUpdateMovieNote,
    hkntUploadFile,
    hkntGetPeriodList,
    hkntGetPeriodById,
    hkntAddPeriod,
    hkntUpdatePeriod,
    hkntUpdatePeriodOrder,
    hkntDeletePeriod,
    hkntBulkDeletePeriod,
    hkntGetParentPeriodList,
    hkntGetMenu,
    hkntGetMenuById,
    hkntUpdateMenu,
    hkntGetProgrammes,
    hkntGetAllProgrammes,
    hkntCreateProgramme,
    hkntGetProgrammeById,
    hkntUpdpateProgrammeById,
    hkntDeleteProgrammeById,
    hkntGetAllAdmins,
    hkntGetAdminsById,
    hkntAddAdmins,
    hkntGetAdminsByRole,
    hkntGetAdminById,
    hkntUpdateAdminById,
    hkntGetRoles,
    hkntGetOptions,
    hkntUpdateOptions,
    hkntImportMovie,
    hkntImportMovieImage,
    hkntImportPage,
    hkntImportPageImage,
  },
};

export default apiHelper;
